export const nl2br = str => {
  let breakTag = '<br ' + '/>'
  return (str||'' + '')
    .replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2')
}


/** WEBPACK FOOTER **
 ** ./src/utils/functions.js
 **/